/* Instructions */
const instructionsTemplate = {
	mainTemplate: {
		type: 'instructions',
		isSolveToContinue: false,
		showProgressBar: true,
		background: null,
		backgroundModifier: null,
		title: null,
		text: null,
		textType: 'speech', // 'info', 'speech',
		characters: ['manager pose-1'],
	}
}

/* Image */
const imageTemplate = {
	mainTemplate: {
		type: 'image',
		isSolveToContinue: false,
		showProgressBar: true,
		image: null,
		text: null,
	}
}

/* Multiple choice */
const multipleChoiceTemplate = {
	mainTemplate: {
		type: 'multiple-choice',
		isSolveToContinue: true,
		isDilemma: false,
		subtype: null, // null, images
		showRequiredNumberOfAnswers: true, // set to false to hide the "choose x answers"
		numberOfAnswersToSelect: 1, // used if isDilemma
		maxPoints: 0, // used if isDilemma
		layout: null, // used if subtype is 'images'
		shuffleOptions: true,
		showProgressBar: true,
		image: null,
		text: null,
		options: [],
		doneEffects: []
	},
	optionTemplate: {
		text: null, 
		isCorrect: false,
		effects: []
	}
};

/* Sort */
const sortTemplate = {
	mainTemplate: {
		type: 'sort',
		subtype: null, // null, images
		isSolveToContinue: true,
		showProgressBar: true,
		layout: '',
		text: null,
		image: null,
		categories: [],
		items: []	
	},
	categoryTemplate: {
		title: null,
		text: null,
	},
	itemTemplate: {
		text: null,
		categoryIds: []
	}
};

/* Order */
const orderTemplate = {
	mainTemplate: {
		type: 'order',
		isSolveToContinue: true,
		showProgressBar: true,
		image: null,
		text: null,
		items: []
	},
	itemTemplate: {
		text: null,
		correctOrderNumbers: []
	}
};

/* Organize */
const organizeTemplate = {
	mainTemplate: {
		type: 'organize',
		isSolveToContinue: true,
		showProgressBar: true,
		showSolutionWhenDone: false,
		layout: '',
		title: null,
		text: null,
		items: [],
		rules: [],
		mainContainers: [],
		doneConditions: [],
		doneEffects: []
	},
	itemTemplate: {
		containerId: null, 
		image: null, 
		alt: null,
		correctContainerIds: []
	},
	mainContainerTemplate: {
		title: null,
		containers: []
	},
	containerTemplate: {
		type: '',
		finalItemId: null
	},
	doneConditionTemplate: {
		type: '', // empty-main-container
		mainContainerId: null
	},
	rulesTemplate: {
		type: '', // items-in-correct-containers
	}
};

/* Spot errors */
const spotErrorsTemplate = {
	mainTemplate: {
		type: 'spot-errors',
		layout: '',
		isSolveToContinue: true,
		showProgressBar: true,
		doneWhenAllErrorsSpotted: false,
		showDefaultResultPopup: true,
		text: null,
		errors: [],
		doneEffects: []
	},
	errorTemplate: {
		effects: []
	}
};

/* Match */
const matchTemplate = {
	mainTemplate: {
		type: 'match',
		isSolveToContinue: true,
		showProgressBar: true,
		layout: null,
		text: null,
		categoriesType: 'text', // text, image
		categoriesTitle: null,
		categories: [],
		itemsType: 'text', // text, image
		itemsTitle: null,
		items: [],
	},
	categoryTemplate: {
		text: null,
		itemIds: []
	},
	itemTemplate: {
		text: null,
		effects: []
	}
}

/* Branching story */
const branchingStoryTemplate = {
	mainTemplate: {
		type: 'branching-story',
		isSolveToContinue: true,
		showProgressBar: true,
		maxPoints: 0,
		text: null,
		steps: []
	},
	stepInfoTemplate: {
		type: 'info',
		isAutoContinue: true,
		nextStepId: null, // null if last step
		title: null,
		text: '',
		textType: 'info', // info, speech
		images: [],
	},
	stepMultipleChoiceTemplate: {
			type: 'multiple-choice',
			shuffleOptions: true,
			showNumberOfAnswersToSelect: true,
			title: null,
			text: '',
			image: null,
			options: []
	},
	stepMultipleChoiceOptionTemplate: {
		text: '', 
		effects: [],
		nextStepId: null // null (stay at story step), id (continue)
	}
};



/* Dialogue */
const dialogueTemplate = {
	mainTemplate: {
		type: 'dialogue',
		isSolveToContinue: true,
		showProgressBar: true,
		showPointsIfCompleted: true,
		characterId: null,
		maxPoints: 0,
		layout: null,
		text: null,
		image: null,
		steps: []
	},
	stepTemplate: {
		type: 'dialogue', // dialog, action
		characterMood: 'neutral', // neutral, happy, angry
		text: null,
		nextStepId: null, // set if auto-continue to next step
		optionType: 'dialogue', // dialogue, action
		optionPrompt: {da: 'Vælg dit svar:'}, 
		options: [],
		effects: []
	},
	stepOptionTemplate: {
		text: '',
		points: 0,
		effects: [],
		nextStepId: null // id (continue) or null (stay at step)
	}
};

export {
	multipleChoiceTemplate,
	instructionsTemplate,
	spotErrorsTemplate,
	organizeTemplate,
	imageTemplate,
	orderTemplate,
	sortTemplate,
	matchTemplate,
	branchingStoryTemplate,
	dialogueTemplate
};
